import { displayTitle, normalizeView, type SavedView } from '@terrazzo/core'
import { store } from '../store/store'

/** A tab's name: its own, or the names of the cards it's inside ("Reno + Garden"). */
export function viewItemTitle(id: string): string {
  const it = store.get(id)
  const inside = it?.props.view ? (normalizeView(it.props.view as SavedView).filter.ancestors ?? []) : []
  const tf = (x: string) => store.get(x)?.title
  return viewTitle(it?.title ?? '', inside.length ? inside.map((a) => displayTitle(store.get(a)?.title ?? '', tf) || 'Untitled').join(' + ') : undefined)
}

export function viewTitle(title: string, rootTitle?: string): string {
  const tf = (x: string) => store.get(x)?.title
  return displayTitle(title, tf) || (rootTitle !== undefined ? displayTitle(rootTitle, tf) || 'Untitled' : 'View')
}
